var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('px-header',{attrs:{"links":_vm.links}}),_c('router-view',{staticClass:"container px-4 sm:px-20 md:px-4 py-20 flex justify-center"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }